import react from "react";
import "./footer.css"

function Footer(){
    return(
        <>
        <footer>
            <p>
            Sample text. Click to select the text box. Click again or double click to start editing the text.          
              </p>
              <section>
            Code by <a href="https://www.facebook.com/Abdullah.Ayman.Yehya/">Abdullah Ayman</a> the ui from <a href="https://nicepage.com/html-templates/preview/it-direction-1328622?device=desktop"> here</a>
        </section>
        </footer>

        
        
        </>
    )
}

export default Footer